export default "__VITE_ASSET__9EHBsdXv__"